import React from 'react';
import PropTypes from 'prop-types';

const ResultCount = ({
  offset, pageSize, total, unfilteredTotal, viewType, pageType,
}) => {
  if (total === 0) return null;

  if (viewType === 'map') {
    return (
      <div className="flex items-center justify-center text-vamos-gray text-lg font-normal">
        <p>{`Displaying ${pageSize} of ${total} ${pageType}`}</p>
      </div>
    );
  }

  const start = offset + 1;
  const end = Math.min(offset + pageSize, total);
  const isFiltered = total !== unfilteredTotal;

  let label;
  if (isFiltered) {
    label = total === 1 ? 'result' : 'results';
  } else {
    label = pageType;
  }

  return (
    <div className="flex items-center text-vamos-gray text-lg font-normal">
      <p>{`Displaying ${start}-${end} of ${total} ${label}`}</p>
    </div>
  );
};

ResultCount.propTypes = {
  offset: PropTypes.number.isRequired,
  pageSize: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  unfilteredTotal: PropTypes.number.isRequired,
  viewType: PropTypes.string.isRequired,
  pageType: PropTypes.string.isRequired,
};

export default ResultCount;
